module.exports = __webpack_public_path__ + "static/media/32.42260b67.jpg";